export const EDIT_SUCCESS = 'Контрагент обновлен';
export const EDIT_ERROR = 'Не удалось обновить контрагента';
